import utils from '@eitje/utils'
import {api as backend} from '../backend'
import {config} from '../config'
import {buildIndexParams, normalizeIndexResponse} from './index_request_helpers'
import {buildScopeRefetchPlan, pruneScopes} from './index_scope'

const MAX_SCOPE_REFETCH_REQUESTS = 20

export async function index(kind, options = {}) {
	const {response, scope, scopesToRefetch} = await performIndexRequest(kind, options)
	const reconciliationSucceeded = await refetchScopes(scopesToRefetch)
	if (response.ok && reconciliationSucceeded) pruneScopes([scope])
	return response
}

const performIndexRequest = async (kind, {inverted, refresh, filters = {}, prunable, params = {}, includeRelatedItems = true} = {}) => {
	const url = `${kind}/index`

	const camelKind = utils.snakeToCamel(kind)
	const {scope, requestParams} = buildIndexParams({name: camelKind, filters, inverted, refresh, prunable, params, includeRelatedItems})
	const finalParams = {
		doNotLoad: true,
		...requestParams,
	}

	const res = await backend.post(url, finalParams)

	if (res.ok) {
		let {data} = res
		data = data || {}
		const changedRelatedScopes = buildScopeRefetchPlan({kind: camelKind, recordIds: data.changed_related_ids || []})
		const normalizedResponse = normalizeIndexResponse({scope, refresh, responseData: data})
		let reconciliationScopes = []

		if (normalizedResponse) {
			config.store.dispatch({
				type: 'INDEX_RECORDS',
				kind: camelKind,
				...normalizedResponse,
				newItems: normalizedResponse.items,
			})

			reconciliationScopes = buildScopeRefetchPlan({kind: camelKind, recordIds: normalizedResponse.removedFromScopeIds})
		}

		return {
			response: {...res, items: normalizedResponse?.items || []},
			scope,
			scopesToRefetch: [...changedRelatedScopes, ...reconciliationScopes],
		}
	} else {
		return {
			response: res,
			scope,
			scopesToRefetch: [],
		}
	}
}

export const refetchScopes = async scopesToRefetch => {
	const queue = [...scopesToRefetch]
	const refetchedScopeIds = new Set()

	while (queue.length > 0) {
		const scope = queue.shift()
		if (refetchedScopeIds.has(scope.id)) continue
		if (refetchedScopeIds.size === MAX_SCOPE_REFETCH_REQUESTS) return false

		refetchedScopeIds.add(scope.id)
		const {response, scopesToRefetch: nextScopes} = await performIndexRequest(utils.camelToSnake(scope.kind), {
			filters: scope.filters,
			prunable: scope.prunable,
			includeRelatedItems: false,
		})

		if (!response.ok) return false

		queue.push(...nextScopes)
	}

	return true
}
